/**
 * Maps an inbound SIP session teardown to the backend call-log status.
 */
export const resolveInboundTerminateStatus = ({
  answered,
  reason,
  durationSec,
  minConnectedSec = 2,
}) => {
  if (reason === "reject") {
    return "REJECTED";
  }
  if (reason === "failed") {
    return "FAILED";
  }
  if (!answered) {
    return "NO_ANSWER";
  }
  if (durationSec < minConnectedSec) {
    return "FAILED";
  }
  return "COMPLETED";
};

/** Best-effort failure reason when sip.js terminates without a captured handler detail. */
export const resolveInboundFailureReason = ({
  answered,
  failureDetail,
  session,
  reason,
  durationSec,
  minConnectedSec = 2,
}) => {
  if (failureDetail) {
    return failureDetail;
  }
  if (session?.isCanceled) {
    return "SIP_CANCEL";
  }
  if (reason === "failed") {
    return "MEDIA_FAILED";
  }
  if (!answered) {
    return "CALLER_HANGUP";
  }
  if (durationSec < minConnectedSec) {
    return "REMOTE_BYE";
  }
  return "CALL_DROPPED_EARLY";
};
